/**
 * Outbound "check current listings" block — never a label that evokes a price or a quote.
 * The query is the player name plus, when a card is linked, its set name; with no card
 * linked it falls back to the name alone.
 */
export function MarketplacePanel({ links, playerName, cardName, nameComplete, setName, t }) {
  if (!links?.length) return null;
  // An abbreviated name ("X. Espart") returns nothing on any marketplace: with no card to
  // borrow the printed full name from, the buttons are a dead end and are not shown.
  const name = cardName || playerName;
  if (nameComplete === false && !cardName) return null;
  const query = encodeURIComponent([name, setName].filter(Boolean).join(" ").trim());
  return (
    <div className="mt-6 rounded-xl p-5 hud-card" data-testid="marketplace-panel">
      <h2 className="mb-1 font-display text-lg font-semibold uppercase tracking-tight text-slate-100">
        {t("cards.listings_title")}
      </h2>
      <p className="mb-4 text-xs text-slate-500">{t("cards.listings_note")}</p>
      <div className="flex flex-wrap gap-2">
        {links.map((m) => (
          <a
            key={m.id}
            href={m.url.replace("{QUERY}", query)}
            target="_blank"
            rel="noopener noreferrer nofollow"
            data-testid={`marketplace-link-${m.id}`}
            className="rounded-md border border-[#1F293D] px-3 py-2 font-mono2 text-[11px] font-bold uppercase tracking-wider text-slate-300 transition-colors hover:border-[#00F0FF]/60 hover:text-[#00F0FF]"
          >
            {m.label} ↗
          </a>
        ))}
      </div>
    </div>
  );
}
